module.exports = __webpack_public_path__ + "static/img/u137.7bdd4fe6.png";